export var INTERNAL_PROPS_MARK = 'RC_SELECT_INTERNAL_PROPS_MARK';


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-select@10.2.1@rc-select/es/interface/generator.js
// module id = 501
// module chunks = 0